<div #filterContainer
  class="common-dropdown-container">
  <span-tooltip
    class="common-table-cell__title-text-label"
    [text]="filterByList.label">
  </span-tooltip>
  <div>
    <button class="common-button__filter-order-button"
      (click)="toggleFilter($event)"
      [disabled]="!list?.length">
      <i class="common-icon__md"
        ngClass="{{item.hasFilter ? 'common-button__filter-order-button--active lf-icon-filter-applied' : 'lf-icon-filter-1'}}">
      </i>
    </button>
    <p-overlayPanel
      [id]="'filterSearch-' + filterByList.id"
      styleClass="common-dropdown-overlay__container">
      <ng-template pTemplate="content">
        @if (filterByList.filterSearch) {
          <div class="common-search__container-tonal">
            <div class="common-search__container-input-text">
              <input
                type="search"
                class="common-search__input-text"
                pAutoFocus
                [autofocus]="true"
                [(ngModel)]="filterByList.inputFilter"
                placeholder="{{'common.search-item' | afTranslate}}">
            </div>
            <div class="common-search__block-button-search">
              @if(filterByList.inputFilter){
                <button class="common-button__icon-xs-noborder"
                  (click)="resetFilter()">
                  <i class="lf-icon-close-thick common-icon__sm"></i>
                </button>
              }
              <div class="h-[22px]"
                ngClass="{{filterByList.inputFilter?'common-divider__vertical-main-1000':'common-divider__vertical-grey-400'}}">
              </div>
              <i class="lf-icon-search common-icon__md"
                ngClass="{{!filterByList.inputFilter ? 'common-search__icon-search-disabled' : 'common-search__icon-search-enabled'}}">
              </i>
            </div>
          </div>
        }
        <div class="common-dropdown__items-container">
          @for (source of list | byWord:filterByList.inputFilter:['name'] | afOrderBy:['specialOrder', item.orderBy]:false; track $index) {
            <button ngClass="{{source.specialOption ? 'common-dropdown-list__si-button-all' : 'common-dropdown-list__si-button'}}"
              (click)="selectElement(source)">
              <div class="common-button__block-button-md-checkbox">
                <button
                  [ngClass]="{'common-button__icon-md-checkbox--selected': source.selected}"
                  class="common-button__icon-md-checkbox">
                  <i class="common-icon__md"
                    ngClass="{{source.selected ? 'lf-icon-check-full' : 'lf-icon-box-inactive'}}">
                  </i>
                </button>
              </div>
              @if(item.iconCircle){
                <div class="common-badge__block-dot-md">
                  <div [class]="'common-badge__dot-md-' + ((source.progressColor?source.progressColor:source.name) | colors: source.progressColor?'highlightListColors':'icon-filter-list')"></div>
                </div>
              }
              <span-tooltip
                class="common-dropdown-list__si-text-container"
                [text]="source.nameToShow"
                [tooltipPosition]="'top'">
              </span-tooltip>
            </button>
          }@empty {
            <span class="common-empty-state__searched-text"
              [afTranslate]="'common.without-results'">
              _Sin resultados
            </span>
          }

        </div>
      </ng-template>
    </p-overlayPanel>
  </div>
  @if (item?.filterOrder) {
    <button class="common-button__filter-order-button"
      [ngClass]="{'common-button__filter-order-button--active' : filterOrder === item?.filterOrder}"
      (click)="orderColumn()">
      <i class="common-icon__md"
        [ngClass]="filterOrder === item?.filterOrder && !order?'lf-icon-arrow-up':'lf-icon-arrow-down'"></i>
    </button>
  }
</div>
